// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Fallbacks keep the app from hard-crashing (blank page) when VITE_ env vars are
// absent from a build — e.g. Cloudflare Pages preview deploys, which don't inherit
// the Production environment variables. These are PUBLIC values (the publishable
// key is RLS-protected and already ships in the client bundle) — safe to commit.
// Production still uses the env vars when they're present.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://sxgsuxntrquqohrfnvmx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "sb_publishable_ZqzzWnD1E0mjABS31tLUVg_7jcgl0P4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});